<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [isLoading$]="isLoading$"
>
  <gc-text class="label">{{ data.label }}</gc-text>
  <div class="buttons-container">
    @if (!data.isDone) {
      <app-mark-as-done-button (markAsDone)="handleMarkAsDone()" />
    }
    <app-options-button
      class="options-button"
      [isDone]="data.isDone"
      [id]="data.id"
    />
  </div>
</app-report-self-inspection-wrapper>
